import { EntityDocfile } from "../../entity/EntityDocfile";

export class DtoDocfilesDeleteRes extends EntityDocfile {
  public message: string | null = null;
}
